enum EAppRoute {
	Partner = '/:partner',
	BusinessAcquisition = `${Partner}/business-acquisition`,
	Debts = `${Partner}/debts`,
	BankStatements = `${Partner}/bank-statements`,
	NotFound = '404',
}

export default EAppRoute;
